export { SaleBannerNew } from './SaleBannerNew'
